(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var bar = document.querySelector('.announcement-bar');
    if (!bar) return;
    var messages = bar.querySelectorAll('.announcement-bar__message');
    if (messages.length <= 1) return;
    var current = 0;
    var rotating = false;

    setInterval(function() {
      if (rotating) return;
      rotating = true;

      messages[current].classList.remove('is-active');
      current = (current + 1) % messages.length;
      messages[current].classList.add('is-active');

      var bgColor = messages[current].getAttribute('data-bg-color');
      var textColor = messages[current].getAttribute('data-text-color');
      if (bgColor) bar.style.backgroundColor = bgColor;
      if (textColor) bar.style.color = textColor;

      setTimeout(function() { rotating = false; }, 700);
    }, 4000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-category-nav]');

    sections.forEach(function (section) {
      var links = section.querySelectorAll('.category-nav__link[data-bg-index]');
      var allBgs = section.querySelectorAll('.category-nav__bg');
      var defaultBg = section.querySelector('.category-nav__bg[data-bg-index="default"]');
      var isMobile = window.matchMedia('(max-width: 767px)');

      function showBackground(index) {
        var prefix = isMobile.matches ? 'mobile-' : '';
        var targetSelector = '.category-nav__bg[data-bg-index="' + prefix + index + '"]';
        var target = section.querySelector(targetSelector);

        allBgs.forEach(function (bg) {
          bg.classList.remove('category-nav__bg--active');
        });

        if (target) {
          target.classList.add('category-nav__bg--active');
        } else if (defaultBg) {
          defaultBg.classList.add('category-nav__bg--active');
        }
      }

      function showDefault() {
        allBgs.forEach(function (bg) {
          bg.classList.remove('category-nav__bg--active');
        });

        if (isMobile.matches) {
          var firstMobile = section.querySelector('.category-nav__bg[data-bg-index="mobile-0"]');
          if (firstMobile) {
            firstMobile.classList.add('category-nav__bg--active');
            return;
          }
        }

        if (defaultBg) {
          defaultBg.classList.add('category-nav__bg--active');
        }
      }

      function clearActiveLinks() {
        links.forEach(function (l) {
          l.classList.remove('is-active');
        });
      }

      if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
        if (isMobile.matches) {
          showDefault();
        }

        links.forEach(function (link) {
          link.addEventListener('click', function (e) {
            var idx = this.getAttribute('data-bg-index');

            if (!this.classList.contains('is-active')) {
              e.preventDefault();
              clearActiveLinks();
              this.classList.add('is-active');
              showBackground(idx);
            }
          });
        });
      } else {
        links.forEach(function (link) {
          link.addEventListener('mouseenter', function () {
            var idx = this.getAttribute('data-bg-index');
            showBackground(idx);
          });
        });

        section.addEventListener('mouseleave', function () {
          showDefault();
        });
      }

      isMobile.addEventListener('change', function () {
        clearActiveLinks();
        showDefault();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-alt"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.featured-collection-alt').forEach(function(section) {
      var track = section.querySelector('[data-fca-track]');
      var prevBtn = section.querySelector('[data-fca-direction="prev"]');
      var nextBtn = section.querySelector('[data-fca-direction="next"]');
      if (!track) return;
      var scrollAmount = 280;

      function isAtEnd() {
        return track.scrollLeft + track.offsetWidth >= track.scrollWidth - 2;
      }
      function isAtStart() {
        return track.scrollLeft <= 2;
      }

      if (prevBtn) prevBtn.addEventListener('click', function() {
        if (isAtStart()) {
          track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        }
      });
      if (nextBtn) nextBtn.addEventListener('click', function() {
        if (isAtEnd()) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.featured-collection').forEach(function(section) {
      var track = section.querySelector('[data-scroll-container]');
      var prevBtn = section.querySelector('[data-direction="prev"]');
      var nextBtn = section.querySelector('[data-direction="next"]');
      if (!track) return;
      var scrollAmount = 280;

      function isAtEnd() {
        return track.scrollLeft + track.offsetWidth >= track.scrollWidth - 2;
      }
      function isAtStart() {
        return track.scrollLeft <= 2;
      }

      if (prevBtn) prevBtn.addEventListener('click', function() {
        if (isAtStart()) {
          track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        }
      });
      if (nextBtn) nextBtn.addEventListener('click', function() {
        if (isAtEnd()) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var popup = document.getElementById('email-popup');
    if (!popup) return;
    if (sessionStorage.getItem('trp-popup-dismissed')) return;
    setTimeout(function() {
      popup.classList.add('is-visible');
      popup.setAttribute('aria-hidden', 'false');
    }, 3000);
    var closeBtn = popup.querySelector('.email-popup__close');
    function dismiss() {
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
      sessionStorage.setItem('trp-popup-dismissed', '1');
    }
    if (closeBtn) closeBtn.addEventListener('click', dismiss);
    popup.addEventListener('click', function(e) { if (e.target === popup) dismiss(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-of-week"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.potw__variant-pill').forEach(function(pill) {
      pill.addEventListener('click', function() {
        pill.parentElement.querySelectorAll('.potw__variant-pill').forEach(function(p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trp-sandwiches"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.trp-sandwiches').forEach(function(section) {
      var track = section.querySelector('[data-trp-sandwiches-track]');
      var prevBtn = section.querySelector('[data-trp-sandwiches-direction="prev"]');
      var nextBtn = section.querySelector('[data-trp-sandwiches-direction="next"]');
      if (!track) return;
      var scrollAmount = 280;

      function isAtEnd() {
        return track.scrollLeft + track.offsetWidth >= track.scrollWidth - 2;
      }
      function isAtStart() {
        return track.scrollLeft <= 2;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          if (isAtStart()) {
            track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
          } else {
            track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
          }
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          if (isAtEnd()) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
          }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
